import { RouterProvider } from 'react-router-dom'
import { Providers } from './providers'
import { router } from './router'
import { PwaInstallPrompt } from '@/shared/components/pwa-install-prompt'
import { PushNotificationInit } from '@/shared/components/push-notification-init'

export default function App() {
  return (
    <Providers>
      <RouterProvider router={router} />
      <PwaInstallPrompt />
      <PushNotificationInit />
    </Providers>
  )
}
